export default __webpack_public_path__ + "static/media/On-demand Automated Urban Shuttle Service.90caa763.pdf";